/**
 * Head-Tail Lottery – Pagination (SEO-friendly)
 *
 * Pagination hoàn toàn server-side qua URL /so-dau-duoi/{region}/page/{num}/
 * JS chỉ xử lý:
 *   1. Province tab switching (full-page navigate)
 *   2. Disabled state cho nút prev/next khi không có href
 */

(function () {
    'use strict';

    /**
     * Province tab click → navigate to page 1 of that region
     */
    document.addEventListener('click', function (e) {
        var tab = e.target.closest('[data-sdd-province]');
        if (!tab) return;
        if (!tab.closest('[data-kqxs-block="so-dau-duoi"]')) return;

        e.preventDefault();

        var provinceMap = {
            'mina': 'mien-nam',
            'mitr': 'mien-trung',
            'miba': 'mien-bac'
        };

        var province = tab.dataset.sddProvince;
        var regionSlug = provinceMap[province] || 'mien-nam';

        // Giữ lại thu param nếu có
        var params = new URLSearchParams(window.location.search);
        var thu = params.get('thu') || '';
        var url = wp_vars.home_url + '/so-dau-duoi/' + regionSlug + '/';
        if (thu) {
            url += '?thu=' + encodeURIComponent(thu);
        }

        window.location.href = url;
    });

    /**
     * Disabled state cho btn--scroll không có href
     */
    document.addEventListener('DOMContentLoaded', function () {
        var buttons = document.querySelectorAll('.pagination .btn--scroll');
        for (var i = 0; i < buttons.length; i++) {
            if (!buttons[i].hasAttribute('href')) {
                buttons[i].style.opacity = '0.3';
                buttons[i].style.cursor = 'default';
                buttons[i].addEventListener('click', function (e) {
                    e.preventDefault();
                });
            }
        }
    });
})();